<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('sint.action') }}</h1>
      <div class="card__description">
        <p>{{ $t('sint.1') }}</p>
        <p>{{ $t('sint.2') }}</p>
        <br />
        <p>{{ $t('sint.3') }}</p>
        <br />
        <p class="font-weight-bold">{{ $t('sint.4') }}</p>
        <br />
        <ul>
          <li>{{ $t('sint.5') }}</li>
          <li>{{ $t('sint.6') }}</li>
          <li>{{ $t('sint.7') }}</li>
          <li>{{ $t('sint.8') }}</li>
          <li>{{ $t('sint.9') }}</li>
        </ul>
        <p class="font-weight-bold">{{ $t('sint.10') }}</p>
        <br />
        <p>{{ $t('sint.11') }} <b-link to="/store">{{ storeUrl }}</b-link> {{ $t('sint.12') }}</p>
        <p>{{ $t('sint.13') }}</p>
        <br />
        <p>{{ $t('sint.14') }}</p>
        <br />
        <p>{{ $t('sint.15') }}</p>
        <br />
        <p class="font-weight-bold">{{ $t('sint.16') }}</p>
        <br />
        <ul>
          <li>{{ $t('sint.17') }}</li>
          <li>{{ $t('sint.18') }}</li>
          <li>{{ $t('sint.19') }}</li>
          <li>{{ $t('sint.20') }}</li>
          <li>{{ $t('sint.21') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'sint',
  metaInfo: function () {
    return {
      title: this.$i18n.t('sint.action') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('sint.action'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  computed: {
    storeUrl: function () {
      return Vue.prototype.$hostname.concat('/store')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Sint.vue